module.exports = __webpack_public_path__ + "static/ApercuPro-Bold-17a955cff9fbe2595ebe6526bf0220ef.woff2";